import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export const EducationForm = ({ data, onChange }) => {
  const addEducation = () => {
    const newEdu = {
      id: Date.now().toString(),
      school: '',
      degree: '',
      year: '',
    };
    onChange([...data, newEdu]);
  };

  const removeEducation = (id) => {
    onChange(data.filter(edu => edu.id !== id));
  };

  const updateEducation = (id, field, value) => {
    onChange(data.map(edu => 
      edu.id === id ? { ...edu, [field]: value } : edu
    ));
  };

  return (
    <div className="space-y-6">
      {data.map((edu, index) => (
        <div key={edu.id} className="p-4 bg-gray-50 rounded-lg border border-gray-200 relative group">
          <div className="absolute top-4 right-4">
             <button onClick={() => removeEducation(edu.id)} className="text-gray-400 hover:text-red-500 transition-colors">
                <Trash2 size={18} />
             </button>
          </div>
          <h3 className="text-sm font-bold text-gray-500 mb-3 uppercase tracking-wider">Education {index + 1}</h3>
          
          <div className="grid grid-cols-1 gap-4">
            <Input 
              label="School / University" 
              value={edu.school} 
              onChange={(e) => updateEducation(edu.id, 'school', e.target.value)} 
            />
            <Input 
              label="Degree / Major" 
              value={edu.degree} 
              onChange={(e) => updateEducation(edu.id, 'degree', e.target.value)} 
            />
            <Input 
              label="Year / Period" 
              value={edu.year} 
              onChange={(e) => updateEducation(edu.id, 'year', e.target.value)} 
              placeholder="e.g. 2018 - 2022"
            />
          </div>
        </div>
      ))}
      
      <Button onClick={addEducation} variant="outline" className="w-full border-dashed">
        <Plus size={18} className="mr-2" /> Add Education
      </Button>
    </div>
  );
};
